import api from "@/services/api";
import type { PesquisaPublicaPayload } from "./pesquisaNps";
import type { GgPerguntaLiderancaDto } from "./genteGestao";

export interface AvaliacaoPublicaPayload extends Omit<PesquisaPublicaPayload, "perguntas"> {
  liderNome?: string;
  perguntas?: GgPerguntaLiderancaDto[];
}

export async function fetchAvaliacaoToken(token: string): Promise<AvaliacaoPublicaPayload> {
  const { data } = await api.get<AvaliacaoPublicaPayload>(
    `/api/pesquisa/lideranca/r/${encodeURIComponent(token)}`,
  );
  return data;
}

export async function enviarAvaliacaoToken(
  token: string,
  itens: Array<{ perguntaId: string; valorNumero?: number | null; valorTexto?: string | null }>,
): Promise<AvaliacaoPublicaPayload> {
  const { data } = await api.post<AvaliacaoPublicaPayload>(
    `/api/pesquisa/lideranca/r/${encodeURIComponent(token)}`,
    { itens },
  );
  return data;
}
